import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const catalogHealthViewAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.catalogHealth],
  permissions: Permission.CatalogHealthView,
}
